import { useState } from 'react'
import { LoginImport } from './Import'
const { login_banner, logo, UserLoginForm, Aos, } = LoginImport

export default function UserLogin() {

    Aos.init();
    const [toggle, setTogggle] = useState(false)

    return (
        <>
            <div className='row side_bg g-0'>
                <div className="col-sm-12 col-lg-7 my-auto">
                    <div>
                        <div className='p-4'>
                            {/* <img src="./favicon.ico" alt="fav" className='img-fluid side_fav_img' /> */}
                            <img src={logo} alt="fav" className='img-fluid side_fav_img' />
                            <h6 className='mt-2 orange'>Welcome to Maintenance Management System</h6>
                        </div>

                        <div className='text-center'>
                            <img src={login_banner} alt="bg" className='img-fluid rounded' style={{ width: '50%' }} />
                        </div>

                        <div className="py-4 px-4">
                            <div className='d-sm-none d-lg-flex justify-content-between align-items-center'>
                                <div className='fw-medium orange' style={{ fontSize: '14px' }}>© Copyright 2025 - RexoAsset. All Right Reserved</div>
                                <div className='fw-medium grey' style={{ fontSize: '14px' }}>Developed by <u className='orange' style={{ cursor: 'pointer' }} onClick={() => window.open('https://www.techlene.com/', '_blank')}>Techlene Software Solutions Pvt. Ltd.</u></div>
                            </div>
                        </div>
                    </div>
                </div>

                {!toggle ?
                    <div className="col-sm-12 col-lg-5 position-relative" data-aos="fade-left" data-aos-duration="1000">
                        <UserLoginForm setTogggle={setTogggle} />
                    </div>
                    : ''
                }

                {toggle ?
                    <div className="col-sm-12 col-lg-5 position-relative" data-aos="fade-left" data-aos-duration="1000">

                    </div>
                    : ''
                }
            </div>
        </>
    )
}
